// src/components/LocationPicker.js
import React, { useRef } from "react";
import { GoogleMap, Marker, Autocomplete } from "@react-google-maps/api";
import { useTranslation } from "react-i18next";
import styled from '@emotion/styled';

const mapContainerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "8px",
  marginBottom: "30px"
};

const center = {
  lat: 40.0853,
  lng: 22.3584,
};


const LangRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const LocationRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FieldGroup = styled.div`
  margin-bottom: 1.5rem;

  label {
    display: block;
    font-weight: bold;
    margin-bottom: 0.5rem;
    color: #385963;
  }

  input, textarea {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 1rem;
  }

  textarea {
    resize: vertical;
    min-height: 100px;
  }
`;


const defaultCenter = { lat: 37.9838, lng: 23.7275 }; // Athens as fallback

const LocationPicker = ({ location, onChange, isLoaded }) => {
  const { t } = useTranslation();
  const autocompleteRef = useRef(null);

  const onPlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();
      if (place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        onChange({ latitude: lat, longitude: lng });
      }
    }
  };

  return (
    <div className="location-picker">

      {!isLoaded ? (
        <p>{t("loading")}</p>
      ) : (
        <>
          {/* Search Bar */}
          <Autocomplete
            onLoad={(ref) => (autocompleteRef.current = ref)}
            onPlaceChanged={onPlaceChanged}
          >
            <input
              type="text"
              placeholder={t("search")}
              style={{
                boxSizing: "border-box",
                border: "1px solid #ccc",
                width: "100%",
                height: "40px",
                padding: "0 12px",
                borderRadius: "8px",
                marginBottom: "10px",
              }}
            />
          </Autocomplete>

          {/* Map */}
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            zoom={8}
            center={
              location.latitude && location.longitude
                ? {
                    lat: parseFloat(location.latitude),
                    lng: parseFloat(location.longitude),
                  }
                : defaultCenter
            }
            onClick={(e) =>
              onChange({
                latitude: e.latLng.lat(),
                longitude: e.latLng.lng(),
              })
            }
          >
            {location.latitude && location.longitude && (
              <Marker
                position={{
                  lat: Number(location.latitude),
                  lng: Number(location.longitude),
                }}
                draggable
                onDragEnd={(e) =>
                  onChange({
                    latitude: e.latLng.lat(),
                    longitude: e.latLng.lng(),
                  })
                }
              />
            )}
          </GoogleMap>
        </>
      )}

     <LocationRow>
        <FieldGroup>
          <label>{t("latitude")}</label>
          <input
            type="number"
            value={location.latitude}
            onChange={(e) =>
              onChange({ ...location, latitude: e.target.value })
            }
            required
          />
        </FieldGroup>
        <FieldGroup>
          <label>{t("longitude")}</label>
          <input
            type="number"
             value={location.longitude}
            onChange={(e) =>
              onChange({ ...location, longitude: e.target.value })
            }
            required
          />
        </FieldGroup>
      </LocationRow>
    </div>
  );
};

export default LocationPicker;

